import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "seating-plan"
};
var _hoisted_2 = {
  class: "chart-container",
  style: {
    "width": "100%",
    "min-width": "400px",
    "min-height": "600px"
  }
};
var _hoisted_3 = ["id"];
var _hoisted_4 = {
  class: "footer",
  style: {
    "position": "absolute",
    "top": "93%",
    "display": "flex",
    "flex-direction": "row",
    "justify-content": "flex-end",
    "align-content": "center",
    "width": "100%"
  }
};
var _hoisted_5 = {
  style: {
    "margin": "10px"
  }
};
var _hoisted_6 = ["disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", null, [_createElementVNode("dialog", null, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
    id: _ctx.chartId,
    style: {
      "min-height": "80vh"
    }
  }, null, 8, _hoisted_3)]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("button", {
    autofocus: "",
    id: "closePopup",
    disabled: _ctx.isCallsInProgress
  }, _toDisplayString(_ctx.isCallsInProgress ? _ctx.$t("common.loading") : _ctx.$t("error.not-available-function-popup-close")), 9, _hoisted_6)])])])])])]);
}